// extracted by mini-css-extract-plugin
module.exports = {"delay":"delay-f888433ebf882b8b46a91425f94d4bd3"};